module.exports = __webpack_public_path__ + "web/img/talk-img2.53a37699.png";